<template lang="pug">
.Toast(
  :class='{ "Toast--error": type === "error", "Toast--success": type === "success", "Toast--progress": type === "progress" }',
  v-show='show',
  @click='hide'
)
  i.Icon.IconWarning(v-if='type === "error"')
  i.Icon.IconSelected(v-if='type === "success"')
  i.Icon.IconDots.IconDots--horizontal(v-if='type === "progress"')
  div(v-html='text')
</template>

<script>
export default {
  name: 'ui-toast',
  data() {
    return {
      timeout: null
    }
  },
  props: {
    show: {
      type: Object | null,
      default: null
    },
    text: String,
    type: String,
    time: {
      type: Number,
      default: 5000
    }
  },
  methods: {
    hide() {
      this.$ui.toast.hide()
    }
  },
  watch: {
    show(val) {
      if (!val) return

      clearTimeout(this.timeout)
      if (this.time > 0) {
        this.timeout = setTimeout(() => {
          this.hide()
        }, this.time)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~base';
.Toast {
  position: fixed;
  bottom: 60px;
  background: #fff;
  left: 50%;
  min-height: 35px;
  max-width: 590px;
  padding: 7px 15px 7px 43px;
  border-radius: 16px;
  font-size: 13px;
  line-height: 16px;
  z-index: 20000;
  transform: translate(-50%, 0);
  display: flex;
  align-items: flex-start;

  div {
    align-self: center;
  }

  &--error {
    background: $red-op80;
    color: $white3;
  }

  &--success {
    background: $green2;
    color: $white3;
  }
  &--progress {
    background: rgba(96, 104, 115, 0.8);
    color: $white3;
  }

  .Icon {
    position: absolute;
    left: 12px;
    top: 50%;
    font-size: 20px;
    margin-top: -11px;
  }

  .IconSelected {
    font-size: 16px;
    margin-top: -8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Toast.vue